import Hero from './Hero';
import Mission from './Mission';
import AppTeaser from './AppTeaser';
import ScaleFrame from './ScaleFrame';
import { SectionSeamUp, SectionSeamDown } from './SectionSeam';

function Home() {
  return (
    <ScaleFrame>
      <Hero />
      <SectionSeamDown />
      <SectionSeamUp />
      <Mission />
      <SectionSeamDown />
      <SectionSeamUp />
      <AppTeaser />
    </ScaleFrame>
  );
}

export default Home;
